import React  from 'react';
import { useUserContext } from '../context/UserContext';

const ListeIntervenants = ({ intervenants }) => {
    const { tableauInitiales } = useUserContext()
    const maxVisible = 5;

  const visibles = (intervenants ?? []).slice(0, maxVisible);
  const reste = (intervenants?.length ?? 0) - maxVisible;
  return (
    <div className="d-flex align-items-center">
      {visibles.map((intervenant) => {
        const match = tableauInitiales.find(i => i.id === intervenant.idIntervenant);
        const initials = match?.initiales ?? '??';

        return (
          <div
            key={intervenant.idIntervenant}
            className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center shadow-sm"
            style={{ width: '30px', height: '30px', marginLeft: -7, fontSize: 12, border: '1px solid white', flexShrink: 0 }}
          >
            {initials}
          </div>
        );
      })}

      {reste > 0 && (
        <div
          className="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center shadow-sm fw-semibold"
          style={{ width: '30px', height: '30px', marginLeft: -7, fontSize: 12, border: '1px solid white', flexShrink: 0 }}
          title={`${reste} de plus`}
        >
          +{reste}
        </div>
      )}
    </div>
  );
};

export default ListeIntervenants;
